import { Card, CardBody } from '@chakra-ui/react'
import { userListContext } from 'BrokerTsLib/src/context'
import type { UserPagedQuery } from 'BrokerTsLib/src/dtos'
import { useSearchUsers } from 'BrokerTsLib/src/hooks/useUser'

import { DashboardHeader } from '@/containers/dashboard/DashboardHeader'
import { UserList } from '@/containers/user/UserList'
import { PageWrapper } from '@/layouts/components/PageWrapper'
import { useSearchParamsStatePersistance } from 'BrokerTsLib/src/hooks/useSearchParamsStatePersistance'

export const UserListPage = () => {

  const initFilter = {
    name: '',
    showInvalid: false,
    pageIndex: 1,
    pageSize: 15,
  }

  const [filter, setFilter] = useSearchParamsStatePersistance<UserPagedQuery>(initFilter)

  const { data, refetch, isLoading, } = useSearchUsers(filter)
  const items = data?.data.items ?? []

  return (
    <PageWrapper
      header={<DashboardHeader title="Přehled uživatelů" />}
      mainProps={{
        sx: {
          pt: { base: 0, md: 8 },
          gap: 4,
          display: 'grid',
          w: '100%',
        },
      }}
    >
      <userListContext.Provider
        value={{
          loading: isLoading,
          totalCount: data?.data?.totalCount ?? 0,
          currentPage: filter.pageIndex,
          pageSize: filter.pageSize ?? 15,
          filter: filter,
          setCurrentPage: (p) => setFilter((value) => ({ ...value, pageIndex: p })),
          setPageSize: (s) => setFilter((value) => ({ ...value, pageSize: s })),
          updateFilter: setFilter,
          reload: refetch,
        }}
      >
        <Card>
          <CardBody display={'flex'} flexDir={'column'}>
            <UserList users={items} />
          </CardBody>
        </Card>
      </userListContext.Provider>
    </PageWrapper>
  )
}
